<template>
    <div class="unit-info-prometheus__wrap unit-info-prometheus-reefer">
        <div class="unit-info-prometheus-reefer__img-container">
            <div class="flex" style="flex-direction: column">
                <button class="button button_view_base button_theme_white unit-info-prometheus-edit-button"
                        style="align-self: flex-end"
                        @click="setRoute.unitEdit($route, $router, unitId)"
                >
                        <span>
                            <SvgIcon name="common__edit" class="icon"/>
                        </span>
                    <span>
                            {{$t('actions.edit')}}
                        </span>
                </button>
                <img :src="require('@/assets/img/reefer-icon/thermo-king.png')" alt="Thermo King">
            </div>
        </div>

        <div class="unit-info-prometheus-reefer__body">
            <div class="unit-info-prometheus__title">{{unit?.name}}</div>

            <div class="unit-info-prometheus-reefer__line"></div>

            <UnitInfo__sensors
                class=""
                :sensors="['type', 'imei', 'last_message', 'address']"
                :unitId="unitId"
            />
            <div class="unit-info-prometheus-reefer__line"></div>

            <button class="button button_view_base button_theme_green mb__20"
                    style="width: 100%"
                    :disabled="isBlockCommands"
                    @click="setCommandAction('onRemoteStart')"
                    v-if="!isPowerOn"
            >
                {{ $t('Reefer.button.Remote Start') }}
            </button>
            <button class="button button_view_base button_theme_red mb__20"
                    style="width: 100%"
                    :disabled="isBlockCommands"
                    @click="setCommandAction('onRemoteStop')"
                    v-else
            >
                {{ $t('Reefer.button.Remote Stop') }}
            </button>
            <button class="button button_view_base button_theme_primary"
                    style="width: 100%"
                    @click="setCommandAction('onSetPinCode')"
            >
                {{ pinCodeAction }}
            </button>

            <div id="sectionInfoByPage" class="page-block" v-show="false"></div>
        </div>

        <custom-modal v-if="modalWindows?.onRemoteStart" v-bind="modalWindows?.onRemoteStart?.props">
            <p class="size-14 text-align-center">{{ $t('Reefer.command_info_send') }}</p>
            <br>
            <p class="size-14 text-align-center">{{ $t('popup.Are you sure') }}</p>
        </custom-modal>
        <custom-modal v-if="modalWindows?.onRemoteStop" v-bind="modalWindows?.onRemoteStop?.props">
            <p class="size-14 text-align-center">{{ $t('Reefer.command_info_send') }}</p>
            <br>
            <p class="size-14 text-align-center">{{ $t('popup.Are you sure') }}</p>
        </custom-modal>

        <!--   custom-modal     -->
        <CommandsConfirmationPINCode
            :action="commandAction"
            @clearAction="clearCommandAction"
            :onlyEdit="onlyPinCodeEdit"
            v-if="commandAction"
        />
    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

import UnitInfo__sensors from "@/components/units/info/UnitInfo__sensors.vue";
import sendCommandMixin from "@/mixins/sendCommandMixin";
import CommandsConfirmationPINCode from "@/components/commands/popup/CommandsConfirmationPINCode.vue";
import unitLmsgMixin from "@/mixins/unitLmsgMixin";

export default {
    setup() {
        return {
            defaultAccordionInfo: ['sensors'],
        }
    },
    name: "UnitInfo_content_reefer",
    mixins: [unitLmsgMixin, sendCommandMixin],
    inject: ['fnAddPageClass','fnRemovePageClass'],
    props: {
        unitId: Number,
    },
    components: {
        CommandsConfirmationPINCode,
        UnitInfo__sensors,
    },
    data() {
        return {
            modalWindows: {},
            disabled: false,
            commandAction: null,
            onlyPinCodeEdit: false,
        }
    },
    computed: {
        ...mapGetters([
            "getAppUser",
            "getCommands",
            "isCommandsFullLoad",
        ]),
        isPowerOn() {
            return this.unitLmsgSensors?.power?.value
        },
        pinCodeAction() {
            let isCmdPinCode = !!this.getAppUser?.cmd_pin_code;
            return (isCmdPinCode ? this.$t('Update') : this.$t('Set')) + ' ' + this.$t('User.Command Pin Code')
        },
        isBlockCommands() {
            return !this.isCommandsFullLoad
                || !this.isUnitLmsgFullLoad
                || this.getCommands?.filter(c => c.unit_id == this.unitId && (!c?.time_answer || c?.time_answer >= (Date.now()/1000))).map(c => c['sub-type'])?.length
        },
    },
    methods: {
        ...mapActions([
            "saveAppUser",
        ]),
        modalClose() {
            this.modalWindows = {}
        },
        clearCommandAction() {
            this.commandAction = null;
            this.onlyPinCodeEdit = false;
        },
        setCommandAction(action) {
            this.onlyPinCodeEdit = action === 'onSetPinCode';
            this.commandAction = () => this[action]()
        },
        onRemoteStart(){
            this.modalWindows = {
                'onRemoteStart':{
                    props:{
                        title: this.$t('Reefer.button.Remote Start'),
                        modalClass: 'modal-600',
                        btnOkClass: 'btn-ok button_theme_neutral',
                        buttons:[
                            {id: 'ok', fn: () => this.sendCmd('RemoteOn')},
                            {id: 'cancel', fn: () => this.modalClose()},
                        ]
                    }
                }
            }
        },
        onRemoteStop(){
            this.modalWindows = {
                'onRemoteStop':{
                    props:{
                        title: this.$t('Reefer.button.Remote Stop'),
                        modalClass: 'modal-600',
                        btnOkClass: 'btn-ok button_theme_neutral',
                        buttons:[
                            {id: 'ok', fn: () => this.sendCmd('RemoteOff')},
                            {id: 'cancel', fn: () => this.modalClose()},
                        ]
                    }
                }
            }
        },
        onSetPinCode() {
            //action in component CommandsConfirmationPINCode
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/scss/02-components/unit-info-prometheus.scss";
</style>